export default "__VITE_ASSET__b25w2m1R__"